// @flow

// COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
import Typeahead from 'fg-frontend/components/Typeahead';

// COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
import PasswordToggle from 'fg-frontend/components/PasswordToggle';

// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
import SocialShare from 'fg-frontend/components/SocialShare';

// COMMON: Komponenta, ktera zajistuje, ze se vertikalni menu zobrazi vzdy pouze v jednom radku (odeberte, pokud na hlavni navigaci nepouzivate)
import GreedyMenu from 'fg-frontend/components/GreedyMenu';

// COMMON: Ostylovani select inputu pomoci knihovny Select2 (odeberte, pokud ostylovani nepouzivate)
import SelectDesign from './components/SelectDesign';

// COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
import Tooltip from './components/Tooltip';

// COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
import GtmHandler from './components/GtmHandler';

// COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
import TriggerInViewport from './components/TriggerInViewport';

// COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
import LazyImage from './components/LazyImage';

// COMMON: Komponenta pro prepinani HTML tridy na danem elementu
import Toggler from './components/Toggler';

// COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
import FGUpload from './components/FGUpload';

// COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
import AlertBox from 'fg-frontend/src/components/AlertBox';

// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
import GoogleRecaptcha from 'fg-frontend/src/components/GoogleRecaptcha';

// COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
import PreventDoubleClickHandler from 'fg-frontend/src/components/PreventDoubleClickHandler';

// Komponenty pouzite primarne v eshopu (obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit)
import configureEshopComponents from './configureEshopComponents';

import AddSvgIconSprite from './components/AddSvgIconSprite';
import Webslider from './components/Webslider';
import Leaderboard from './components/Leaderboard';
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import RadioSelectTab from 'fg-frontend/src/components/RadioSelectTab';
import NumberInput from 'fg-frontend/components/NumberInput';
import SimpleCollapse from 'fg-frontend/components/SimpleCollapse';
import ShareUrl from 'fg-frontend/src/components/ShareUrl';
import AnchorsList from 'fg-frontend/src/components/AnchorsList';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'AddSvgIconSprite':
			return AddSvgIconSprite;
		case 'RadioSelect':
			return RadioSelect;
		case 'RadioSelectTab':
			return RadioSelectTab;
		case 'NumberInput':
			return NumberInput;
		case 'SimpleCollapse':
			return SimpleCollapse;
		case 'AnchorsList':
			return AnchorsList;
		case 'ShareUrl':
			return ShareUrl;
		case 'GreedyMenu':
			return GreedyMenu;
		case 'Typeahead':
			return Typeahead;
		case 'SelectDesign':
			return SelectDesign;
		case 'PasswordToggle':
			return PasswordToggle;
		case 'SocialShare':
			return SocialShare;
		case 'Webslider':
			return Webslider;
		case 'Tooltip':
			return Tooltip;
		case 'GtmHandler':
			return GtmHandler;
		case 'TriggerInViewport':
			return TriggerInViewport;
		case 'LazyImage':
			return LazyImage;
		case 'Toggler':
			return Toggler;
		case 'FGUpload':
			return FGUpload;
		case 'AlertBox':
			return AlertBox;
		case 'GoogleRecaptcha':
			return GoogleRecaptcha;
    case 'Leaderboard':
      return Leaderboard;
    case 'PreventDoubleClickHandler':
      return PreventDoubleClickHandler;
		default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			} else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/configureWebComponents.js